// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2lf-9","column":"style_column__ymkTV","row":"style_row__1nQdT"};